import { CurrencyItem } from '@/models/dictionary/currency-list.model';
import { defineStore } from 'pinia';
import { api } from '@/services/http.service';
import { ElNotification } from 'element-plus';

interface CurrencyListStore {
  currencyList: CurrencyItem[];
  isCurrencyListLoading: boolean;
}

export const useCurrencyListStore = defineStore({
  id: 'CurrencyListStore',
  state: (): CurrencyListStore => ({
    currencyList: [],
    isCurrencyListLoading: false,
  }),
  actions: {
    setCurrencyListLoading(isLoading: boolean): void {
      this.isCurrencyListLoading = isLoading;
    },
    getCurrencyList(): Promise<CurrencyItem[]> {
      if (this.currencyList.length) {
        return Promise.resolve(this.currencyList);
      }

      this.setCurrencyListLoading(true);

      return api.dictionary.getCurrencyListRequest.perform()
        .then((data: CurrencyItem[]) => {
          this.currencyList = data;

          return data;
        })
        .catch(error => {
          ElNotification({
            title: 'Error',
            message: error?.response?.data?.message,
            type: 'error',
          });

          return [];
        }).finally(() => {
          this.setCurrencyListLoading(false);
        });
    },
  },
});
